import type { MuniSummary } from "../types/tariffs";

export function tariffAuthorityLabel(summary: Pick<MuniSummary, "providers" | "providerStatus">): string {
  if (summary.providerStatus === "verified-service-area") {
    return summary.providers.length ? summary.providers.join(", ") : "Verified authority not named";
  }
  if (summary.providerStatus === "authority-record") {
    return summary.providers.length ? `Approval record: ${summary.providers.join(", ")}` : "Authority approval record found";
  }
  return "Electricity service area not mapped";
}

export function tariffAuthorityStatusLabel(providerStatus: MuniSummary["providerStatus"]): string {
  if (providerStatus === "verified-service-area") return "Service area checked";
  if (providerStatus === "authority-record") return "Authority record only";
  return "Service area not assessed";
}
